export const addCommas = (str) => Number(str).toLocaleString("en-US")